import { type AnyAction, combineReducers } from 'redux';

import { hideModal, showModal } from 'js/src/data/modals/modals-actions';
import type { MODAL_IDS } from 'js/src/data/modals/modals-types';

/**
 * A stack of strings is used to keep track of visible modals. The modal at the top
 * of the stack, if any, is the modal currently being shown
 */
const NO_MODALS: readonly MODAL_IDS[] = [];
const NO_MODAL_CONTEXTS: readonly unknown[] = [];

const withoutTop = <T>(stack: readonly T[]): readonly T[] =>
    stack.length === 0 ? stack : stack.slice(0, -1);

export function visible_stack(state = NO_MODALS, action: AnyAction): readonly MODAL_IDS[] {
    if (showModal.match(action)) {
        return [...state, action.payload.modal_id];
    }
    if (hideModal.match(action)) {
        return withoutTop(state);
    }
    return state;
}

/**
 * A stack containing any data type used to keep track of any custom data. This stack
 * is kept in sync with the visible_stack defined above.
 */
export function visible_stack_context(
    state = NO_MODAL_CONTEXTS,
    action: AnyAction,
): readonly unknown[] {
    if (showModal.match(action)) {
        return [...state, action.payload.modal_context];
    }
    if (hideModal.match(action)) {
        return withoutTop(state);
    }
    return state;
}

export const modals = combineReducers({
    visible_stack,
    visible_stack_context,
});

export type ModalsState = ReturnType<typeof modals>;
